import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.colors.background,
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    loadingText: {
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
      fontSize: "16px",
      marginTop: "124px",
    },
    loaderOuter: {
      marginTop: 48,
      height: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    loader: {
      display: "flex",
    },
    dot: {
      width: 15,
      height: 15,
      display: "block",
      borderRadius: "50%",
      position: "relative",
      margin: "0 12px",
      backgroundColor: "#D9D9D9",
    },
    dot1: {
      animation: `$loaderAnimation 1.5s linear 0s infinite`,
    },
    dot2: {
      animation: `$loaderAnimation 1.5s linear 0.33s infinite`,
    },
    dot3: {
      animation: `$loaderAnimation 1.5s linear 0.67s infinite`,
    },
    "@keyframes loaderAnimation": {
      "0%": {
        transform: "scale(1)",
      },
      "25%": {
        transform: "scale(1.5)",
      },
      "50%": {
        transform: "scale(1)",
      },
      "75%": {
        transform: "scale(1)",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
